var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.cols),function(col){return _c('div',{key:col.key,class:`col-xs-12 col-sm-${col.size}`},[_vm._v(" "+_vm._s(_vm.data[col.key])+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }